// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type IndexCheckQueryVariables = Types.Exact<{
  queryId: Types.Scalars["ID"]["input"];
}>;

export type IndexCheckQuery = {
  __typename?: "GraphqlQuery";
  getQueryIndexCheck: {
    __typename?: "QueryIndexCheck";
    timedOut: boolean;
    failedToParse: boolean;
    tables: Array<{
      __typename?: "QueryIndexCheckTable";
      table: {
        __typename?: "SchemaTable";
        id: string;
        schemaName: string;
        tableName: string;
        lastStats?: {
          __typename?: "SchemaTableInlineStats";
          dataSizeBytes?: number | null;
          liveTuples?: number | null;
        } | null;
      };
      columnsIndexed: Array<{
        __typename?: "QueryIndexCheckIndexedColumn";
        column: { __typename?: "SchemaColumn"; name: string };
        index: {
          __typename?: "SchemaIndex";
          id: string;
          name: string;
          definitionShort: string;
        };
      } | null>;
      columnsMissingIndex: Array<{
        __typename?: "SchemaColumn";
        name: string;
      } | null>;
    } | null>;
  };
};

export const IndexCheckDocument = gql`
  query IndexCheck($queryId: ID!) {
    getQueryIndexCheck(queryId: $queryId) {
      tables {
        table {
          id
          schemaName
          tableName
          lastStats {
            dataSizeBytes
            liveTuples
          }
        }
        columnsIndexed {
          column {
            name
          }
          index {
            id
            name
            definitionShort
          }
        }
        columnsMissingIndex {
          name
        }
      }
      timedOut
      failedToParse
    }
  }
`;

/**
 * __useIndexCheckQuery__
 *
 * To run a query within a React component, call `useIndexCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndexCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexCheckQuery({
 *   variables: {
 *      queryId: // value for 'queryId'
 *   },
 * });
 */
export function useIndexCheckQuery(
  baseOptions: Apollo.QueryHookOptions<
    IndexCheckQuery,
    IndexCheckQueryVariables
  > &
    (
      | { variables: IndexCheckQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IndexCheckQuery, IndexCheckQueryVariables>(
    IndexCheckDocument,
    options,
  );
}
export function useIndexCheckLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IndexCheckQuery,
    IndexCheckQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IndexCheckQuery, IndexCheckQueryVariables>(
    IndexCheckDocument,
    options,
  );
}
// @ts-ignore
export function useIndexCheckSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IndexCheckQuery,
    IndexCheckQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<IndexCheckQuery, IndexCheckQueryVariables>;
export function useIndexCheckSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IndexCheckQuery,
        IndexCheckQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IndexCheckQuery | undefined,
  IndexCheckQueryVariables
>;
export function useIndexCheckSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IndexCheckQuery,
        IndexCheckQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IndexCheckQuery, IndexCheckQueryVariables>(
    IndexCheckDocument,
    options,
  );
}
export type IndexCheckQueryHookResult = ReturnType<typeof useIndexCheckQuery>;
export type IndexCheckLazyQueryHookResult = ReturnType<
  typeof useIndexCheckLazyQuery
>;
export type IndexCheckSuspenseQueryHookResult = ReturnType<
  typeof useIndexCheckSuspenseQuery
>;
export type IndexCheckQueryResult = Apollo.QueryResult<
  IndexCheckQuery,
  IndexCheckQueryVariables
>;
